import { render, staticRenderFns } from "./pull.vue?vue&type=template&id=2e61a3c8"
import script from "./pull.vue?vue&type=script&lang=js"
export * from "./pull.vue?vue&type=script&lang=js"
import style0 from "./pull.vue?vue&type=style&index=0&id=2e61a3c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports